const Deps = {
  getLocale: null,
  wire: null,
  I18n: null
};

export default Deps;
